import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"


export const Temperature = ({ label, value }: { label: string, value: number }) => {
  return <Box
    sx={{
      flexDirection: "column",
      alignItems: "center",
      display: value === -1 ? 'none' : 'flex',
    }}
  >
    <Typography fontSize="calc(0.3rem + 0.6vw)">
      {value}
      {"°C"}
    </Typography>
    <Typography fontSize="calc(0.3rem + 0.5vw)" mt="-10%" fontWeight="400">{label}</Typography>
  </Box>
}
